export function mapValues<TOutputValue, TObject extends Record<string, unknown>>(
    obj: TObject,
    fn: (value: TObject[keyof TObject], key: keyof TObject) => TOutputValue,
): { [K in keyof TObject]: TOutputValue } {
    const keys = Object.keys(obj) as Array<keyof TObject>;
    return keys.reduce((carry, key) => ({ ...carry, [key]: fn(obj[key], key) }), {}) as {
        [K in keyof TObject]: TOutputValue;
    };
}
